import React, { useState } from "react";
import styles from './PopupBase.module.css';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Dialog from '@mui/material/Dialog';
import { Fade, Grow } from '@mui/material';

function PopupBase(props) {
    const { Title, Content, Footer, PositiveButton, NegativeButton, OnClose, maxWidth } = props;
    const [open, setOpen] = useState(true);

    // Função para fechar o popup instantaneamente
    function handleClose() {
        setOpen(false);
        OnClose();
    }

    // Determinar a largura máxima do Dialog
    const getMaxWidth = () => {
        if (!maxWidth) return 'lg';
        if (maxWidth === 'xl') return false; // Usamos false para permitir maxWidth personalizado via classes
        if (maxWidth === 'auto') return false; // Usamos false para permitir que o Dialog se ajuste ao conteúdo
        return maxWidth;
    };

    // Estilo personalizado para o Dialog quando maxWidth é 'xl' ou 'auto'
    const dialogPaperStyle = maxWidth === 'xl'
        ? { maxWidth: '1400px' }
        : maxWidth === 'auto'
            ? { width: 'auto', maxWidth: 'fit-content' }
            : {};

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={getMaxWidth()}
            fullWidth
            PaperProps={{
                className: styles.dialogPaper,
                style: dialogPaperStyle
            }}
            TransitionComponent={Grow}
            TransitionProps={{
                timeout: {
                    enter: 300,
                    exit: 0
                },
                style: {
                    transformOrigin: 'center center'
                }
            }}
            BackdropProps={{
                TransitionComponent: Fade,
                timeout: {
                    enter: 300,
                    exit: 0
                },
                sx: {
                    backgroundColor: 'rgba(15, 23, 42, 0.55)',
                    backdropFilter: 'blur(3px)',
                }
            }}
            aria-labelledby="popup-title"
            disableScrollLock={false}
        >
            <div className={styles.header}>
                <h2 className={styles.title} id="popup-title">{Title}</h2>
                <button type="button" className={styles.closeButton} onClick={handleClose} aria-label="Fechar">
                    <CloseOutlinedIcon
                        className={styles.close}
                        aria-hidden="true"
                        sx={{
                            fontSize: '1.375rem !important',
                            color: '#94a3b8',
                            cursor: 'pointer',
                            borderRadius: '6px',
                            padding: '3px',
                            transition: 'background 0.15s ease, color 0.15s ease',
                            flexShrink: 0,
                            '&:hover': {
                                background: '#f1f5f9',
                                color: '#475569',
                            },
                        }}
                    />
                </button>
            </div>
            {(Content || Footer || NegativeButton || PositiveButton) && (
                <hr className={styles.divider} />
            )}
            <div className={styles.content}>
                {Content}
            </div>
            <div className={styles.footer}>
                {Footer}
            </div>
            <div className={styles.buttons}>
                {NegativeButton}
                {PositiveButton}
            </div>
        </Dialog>
    );
}

export default PopupBase;
